import { LabMDM } from "./lab";
import { OperetionHistoryDTO } from "./operationHistory";

//this model is used to add the sender
export class SenderDTO {
    _id : string;
    senderName : string;
    lab : LabMDM;
    senderShortName : string;
    barcodeFormat : string;
    trfBarcode : string;
    trfFormat : string;
    boxBarcode : string;
    boxBarcodeFormat : string;
    externalSampleBarcode : string;
    externalSampleFormat : string;
    checkForIdentity : string;
    mergeGroup : string;
    active : boolean;
    version : number;
    barcodeValidationRequired: boolean;
    dataFormat: string;
    contactID: string ;
    swabType: string;
    barcodeExistOnBag: boolean;
    categoryType: string[];
    defaultPriority: string;
    allowedPCRKits: string[] = [];
    allowedExtractionKits: string[] = [];
    allowedCyclerTypes: string[] = [];
    allowedExtractorTypes: string[] = [];
    storageTime : number;
    senderGroupName: string;
    regionalCodes : string[];
    history:OperetionHistoryDTO[];
}
